/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * reserveTripsReport
 * @export
 * @interface ReserveTripsRequest
 */
export interface ReserveTripsRequest {
    /**
     * 複数のログイン/ログアウトを乗務単位にまとめるためのID
     * @type {string}
     * @memberof ReserveTripsRequest
     */
    shiftId: string;
    /**
     * 営業所ID
     * @type {number}
     * @memberof ReserveTripsRequest
     */
    officeId: number;
}

export function ReserveTripsRequestFromJSON(json: any): ReserveTripsRequest {
    return ReserveTripsRequestFromJSONTyped(json, false);
}

export function ReserveTripsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveTripsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shiftId': json['shift_id'],
        'officeId': json['office_id'],
    };
}

export function ReserveTripsRequestToJSON(value?: ReserveTripsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shift_id': value.shiftId,
        'office_id': value.officeId,
    };
}


